// @flow

import React, { Component } from 'react'
import { select } from 'd3-selection'

type Props = {
  h: number,
  gridType: string,
  grid: Object,
}

export default class Grid extends Component<Props> {
  // this Node here is type svg flow still don't provide support to svg typing
  //see more https://github.com/facebook/flow/pull/4551
  node: any

  componentDidUpdate() {
    this.renderGrid()
  }

  componentDidMount() {
    this.renderGrid()
  }

  renderGrid = () => select(this.node).call(this.props.grid)

  render() {
    const translate = `translate(0,${this.props.h})`
    return (
      <g
        ref={node => (this.node = node)}
        className="y-grid"
        transform={this.props.gridType === 'x' ? translate : ''}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/Grid.js